import React, { useCallback, useState } from 'react'
import { DockablePanel } from 'src/components/Reusable/DockablePanel/DockablePanel'
import { useAnalytics } from '../analytics/useAnalytics'
import { useInfoPanelContext } from './InfoPanelContext'

export const InfoPanel = (): JSX.Element => {
  const [attached, setAttached] = useState(false)
  const { track, events } = useAnalytics()
  const { infoPanelState, setInfoPanelState } = useInfoPanelContext()
  const { isShown, render, title } = infoPanelState
  const content = isShown ? render : <></>

  const close = useCallback(() => {
    track(events.V_ACTIVITY_LOG, { toggle: 'close', source: 'panel' })
    setInfoPanelState({
      isShown: false,
      render: <div></div>,
    })
  }, [track, setInfoPanelState, events])

  return (
    <DockablePanel
      title={title || 'Activities'}
      show={isShown}
      width={360}
      onClose={close}
      attached={attached}
      onAttach={() => setAttached(true)}
      onDetach={() => setAttached(false)}
    >
      {content}
    </DockablePanel>
  )
}
